import { render, staticRenderFns } from "./TemplatesFilters.vue?vue&type=template&id=0b4bc2a1&"
import script from "./TemplatesFilters.vue?vue&type=script&lang=js&"
export * from "./TemplatesFilters.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
